import { render, staticRenderFns } from "./survey-scheduled.vue?vue&type=template&id=4522d10d"
import script from "./survey-scheduled.vue?vue&type=script&lang=js"
export * from "./survey-scheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports